/* GRIZZLY — Auto image-to-PDP linking inside blog articles (System C)
 * --------------------------------------------------------------------
 * Scans every <img> inside the article body, reads its alt (or title) attr,
 * and if the alt mentions a known scent / bundle, wraps the image in an
 * anchor pointing to the relevant PDP. Pure progressive enhancement — if
 * the script fails to load, articles still render fine.
 */

(function() {
  if (window.__grizzlyArticleImgLinks) return;
  window.__grizzlyArticleImgLinks = true;

  // Map of alt-text keywords → product handle
  // Order matters: longer/more-specific keywords first.
  var SCENT_MAP = [
    /* ---- Bundles (always link to bundle PDP) ---- */
    { keywords: ['מארז של עשרה', 'מארז 10', '10-pack'], handle: '10-pack' },
    { keywords: ['מארז של שמונה', 'מארז 8', '8-pack'],  handle: '8-pack' },
    { keywords: ['מארז של שישה', 'מארז 6', '6-pack'],   handle: '6-pack' },
    { keywords: ['מארז של ארבעה', 'מארז 4', '4-pack'],  handle: '4-pack' },
    { keywords: ['בנה מארז', 'תרכיב מארז', 'build a box', 'build-a-box'], handle: 'build-a-box-page' },

    /* ---- Single soaps ---- */
    { keywords: ['היער השחור', 'יער שחור', 'black forest'],            handle: 'black-forest' },
    { keywords: ['רום אקזוטי', 'exotic rum'],                          handle: 'exotic-rum' },
    { keywords: ['וויסקי אלון מיושן', 'וויסקי אלון', 'aged oak whiskey', 'oak whiskey'], handle: 'aged-oak-whiskey' },
    { keywords: ['קוקוס אי בודד', 'lone coconut island', 'אי בודד'],   handle: 'lone-coconut-island' },
    { keywords: ['אלוורה רעננה', 'fresh aloe', 'אלוורה'],              handle: 'fresh-aloe' },
    { keywords: ['בריזת מפלים', 'falls breeze', 'מפלים'],              handle: 'falls-breeze' },
    { keywords: ['חלב ודבש', 'milk and honey', 'milk & honey'],        handle: 'milk-and-honey' }
  ];

  function findHandle(text) {
    if (!text) return null;
    var lower = String(text).toLowerCase();
    for (var i = 0; i < SCENT_MAP.length; i++) {
      var entry = SCENT_MAP[i];
      for (var j = 0; j < entry.keywords.length; j++) {
        if (lower.indexOf(entry.keywords[j].toLowerCase()) !== -1) {
          return entry.handle;
        }
      }
    }
    return null;
  }

  function wrapImageInLink(img, handle) {
    if (img.closest('a')) return; // already linked — don't double-wrap
    var url = handle === 'build-a-box-page'
      ? '/pages/build-a-box'
      : '/products/' + handle;
    var a = document.createElement('a');
    a.href = url;
    a.style.display = 'inline-block';
    a.setAttribute('aria-label', img.alt || handle);
    a.setAttribute('data-grizzly-auto-link', '1');
    img.parentNode.insertBefore(a, img);
    a.appendChild(img);
  }

  function processArticle() {
    var article = document.querySelector(
      'article[itemtype*="BlogPosting"], main article, .article__content, .article-template, .article-body'
    );
    if (!article) return;
    var imgs = article.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var handle = findHandle(img.alt) || findHandle(img.title);
      if (handle) wrapImageInLink(img, handle);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processArticle, { once: true });
  } else {
    processArticle();
  }
})();